import { mundipaggInstance } from '@payments-checkout/shared/helpers/index';
import { isValidLanguage } from '@payments-checkout/shared/helpers/translations/messages.helper';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError, AxiosResponse } from 'axios';

export type CountryResponse = Array<{
  code: string;
  name: string;
}>;

const getStatesList = async ({
  language = 'pt',
  country,
}: {
  language?: string;
  country: string;
}) => {
  if(!country) throw new Error('Invalid country')
  if(!isValidLanguage(language)) throw new Error('Invalid language')

  const response = await mundipaggInstance.get<CountryResponse>(
    `/maps/v1.0/${country}/states/${language}`
  );
  return response;
};

const useStatesList = ({
  language,
  country,
}: {
  language?: string;
  country: string;
}) => {
  const query = useQuery<AxiosResponse<CountryResponse>, AxiosError>({
    queryKey: ['useStatesList', language, country],
    queryFn: async () => getStatesList({ language, country }),
    refetchOnWindowFocus: false,
    staleTime: 0,
    retry: 0,
    enabled: Boolean(country),
  });

  return { ...query, data: query.data?.data };
};

export { getStatesList, useStatesList };

